import { ApiShopperLandingPage } from '@storefronts/common-types'
import { useState } from 'react'
import { AnalyticsTracker } from '../../analytics/tracking'
import { AnalyticsContext } from '../../context/analyticsContext'

type AnalyticsProviderProps = {
    children: React.ReactNode
    resource: ApiShopperLandingPage
    analyticsIdentifier?: string
}

function getOrCreateAnalyticsTracker(
    resource: ApiShopperLandingPage,
    analyticsIdentifier?: string,
): AnalyticsTracker {
    if (typeof window === 'undefined') {
        return new AnalyticsTracker()
    }

    if (
        analyticsIdentifier &&
        window.viddyTrackers &&
        analyticsIdentifier in window.viddyTrackers
    ) {
        return window.viddyTrackers[analyticsIdentifier]
    }

    const key = resource.landingPageHash

    if (window.viddyTrackers && key in window.viddyTrackers) {
        return window.viddyTrackers[key]
    }

    const tracker = new AnalyticsTracker()
    tracker.initialize({
        format: 'vlp',
        landingPage: resource,
    })

    window.viddyTrackers = window.viddyTrackers || {}
    window.viddyTrackers[key] = tracker
    return tracker
}

export const AnalyticsProvider: React.FC<AnalyticsProviderProps> = ({
    children,
    resource,
    analyticsIdentifier,
}) => {
    // Registered once with window object; not re-derived on prop changes.
    const [analytics] = useState<AnalyticsTracker>(() =>
        getOrCreateAnalyticsTracker(resource, analyticsIdentifier),
    )

    const analyticsContext: AnalyticsContext = {
        Analytics: analytics,
    }
    return (
        <AnalyticsContext.Provider value={analyticsContext}>
            {children}
        </AnalyticsContext.Provider>
    )
}
